import React from 'react';
import { Box, Container, Typography, Paper, Link } from '@mui/material';
import Navbar from '../components/core/Navbar';
import Footer from '../components/core/Footer';

const ContactPage = () => {
  return (
    <>
      <Navbar />
      <Box sx={{ py: 8 }}>
        <Container maxWidth="md">
          <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
            <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ fontWeight: 700 }}>
              Contact Us
            </Typography>
            
            <Typography variant="h6" align="center" color="text.secondary" paragraph>
              Have questions? We're here to help.
            </Typography>

            <Box sx={{ mt: 4, textAlign: 'center' }}>
              <Typography variant="body1" paragraph>
                For any inquiries, please reach out to us at:
              </Typography>
              
              <Link 
                href="mailto:mike@numerease.com"
                sx={{ 
                  fontSize: '1.2rem',
                  color: 'primary.main',
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                mike@numerease.com
              </Link>
            </Box>
          </Paper>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default ContactPage; 